import React, { Component } from 'react';
import Cookies from 'js-cookie';

class Config {
	/*
	jenis layanan: 1 home care, ambulance 2, laboratorium 3, obat 4
	*/
	get_site_info() {
		return {
			name: 'Pusat Data',
			logo: process.env.PUBLIC_URL + "/assets/images/logo.png",
			logo_landscape: process.env.PUBLIC_URL + "/assets/images/logo.png",
			description: 'Pusat Data'
		}
	}

	get_server_url() {
		const prod = 'https://dev-pusatdata_api-simlala.kemenhub.go.id/'// 'https://dev-api-simlala.kemenhub.go.id';
		const dev = 'https://dev-pusatdata_api-simlala.kemenhub.go.id/'// 'https://dev-api-simlala.kemenhub.go.id';
		// const dev = 'https://json.psty.io/api_v1/stores';

		if (Cookies.get("mode") == "prod") {
			return prod;
		} else {
			return dev;
		}
	}

	get_base_url() {
		const prod = 'https://dev-pusatdata_api-simlala.kemenhub.go.id/'// 'https://dev-api-simlala.kemenhub.go.id';
		const dev = 'https://dev-pusatdata_api-simlala.kemenhub.go.id/'//F'https://dev-api-simlala.kemenhub.go.id';

		if (Cookies.get("is_prod")) {
			return prod;
		} else {
			return dev;
		}
	}

	get_web_socket() {
		return '';
	}

	get_date_id(date, showTime = 0) {
		if (date == null) {
			return "-";
		} else {
			//2022-12-31 23:59:00
			const temp1 = date.split(" ");
			var result = "";

			const temp2 = temp1[0].split("-");
			result += temp2[2];
			result += " " + this.get_bulan_name(parseFloat(temp2[1]));
			result += " " + temp2[0];

			if (temp1.length == 2 && showTime == 1) {//datetime
				const temp3 = temp1[1].split(".");
				const temp4 = temp3[0].split(":");
				result += " " + temp4[0] + ":" + temp4[1];
			}
			return result;

		}
	}

	get_bulan_name(value) {
		value = parseFloat(value) + "";
		var bulan = "";
		switch (value) {
			case "1":
				bulan = "Jan"
				break;
			case "2":
				bulan = "Feb"
				break;
			case "3":
				bulan = "Mar"
				break;
			case "4":
				bulan = "Apr"
				break;
			case "5":
				bulan = "Mei"
				break;
			case "6":
				bulan = "Jun"
				break;
			case "7":
				bulan = "Jul"
				break;
			case "8":
				bulan = "Agu"
				break;
			case "9":
				bulan = "Sep"
				break;
			case "10":
				bulan = "Okt"
				break;
			case "11":
				bulan = "Nov"
				break;
			case "12":
				bulan = "Des"
				break;
			default:
		}
		return bulan
	}

	get_cookie_name() {
		return 'r4simL4_cr4uth';
	}

	get_cookie_time() {
		return 1 / 24;//1 jam
	}

	cekManualValidasi(formRef) {
		var isValid = true;

		const cekValidasi = formRef.current.validateFields();
		formRef.current.validateFields().then((val) => {
			// isValid = 
			// console.log('validasi', val)
		}).catch(err => {
			const errField = err.errorFields;
			if (errField.length > 0) {
				for (var i = 0; i < errField.length; i++) {

					formRef.current.getFieldInstance(errField[i].name[0]).focus();
					isValid = false;
					// console.log('sini', isValid)
					break;

				}

			}
			// console.log('sini2', isValid)
		});
		return isValid;
	}

	stripTags(teks) {
		var temp = teks.replace(/&nbsp;/, "");
		return temp.replace(/(<([^>]+)>)/ig, "");//strip tags html
	}

	escape_str(value) {
		return (
			<div>
				{value.includes("https://") || value.includes("http://") || value.includes("www.")
					?
					<div>
						<a href={value} target="_blank">{value}</a>
					</div>
					:
					value
				}
			</div>
		);
	}

	cm_to_pixel(cm) {
		return cm * 37.7952755906;
	}

	getSlug(teks) {
		//Peresmian Jalan Tol Serang – Panimbang, Presiden Jokowi: Infrastruktur adalah Fondasi Negara Kita untuk Bersaing Dengan Negara Lain
		var temp = teks.trim();
		temp = temp.replace(/-/g, '');//dash
		temp = temp.replace(/–/g, '');//dash special
		temp = temp.replace(/\s+/g, '-').toLowerCase();//space
		temp = temp.replace(/(<([^>]+)>)/ig, "");//strip tags html
		// temp = temp.replace(/,()/ig, "");//()
		temp = temp.replace(/[,+\/*%@!?&$#^:'"{}()<>:'"]/g, "");
		return encodeURIComponent(temp);
	}

	numberFormat(val, isUang = false) {
		var sign = 1;
		if (val < 0) {
			sign = -1;
			val = -val;
		}

		// trim the number decimal point if it exists
		let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();

		while (/(\d+)(\d{3})/.test(num.toString())) {
			// insert comma to 4th last position to the match number
			num = num.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
		}

		// add number after decimal point
		if (val.toString().includes('.')) {
			num = num + '.' + val.toString().split('.')[1];
		}

		// return result with - sign if negative
		if (isUang)
			return sign < 0 ? '-' + num + ",00" : num + ",00";
		else return sign < 0 ? '-' + num : num;
	}
}
export default Config
